// extracted by mini-css-extract-plugin
module.exports = {"componentStyle":"Badge_componentStyle___w0V3","default":"Badge_default__BZ5jf","large":"Badge_large__lEDZd"};